import {
    CircularProgress,
    Grid,
    InputAdornment,
    TextField, Button,Box
  } from "@mui/material";
  import { Search, SentimentDissatisfied } from "@mui/icons-material";
  import { useParams } from "react-router-dom";
  import React, { useEffect, useState } from "react";
  import Header from "./Header";
  import UploadIcon from '@mui/icons-material/Upload';
  import { useSnackbar } from "notistack";
  import axios from "axios";
  import MovieCard from "./MovieCard";
  import InputLabel from '@mui/material/InputLabel';
  import MenuItem from '@mui/material/MenuItem';
  import FormControl from '@mui/material/FormControl';
  import Select from '@mui/material/Select';
  import { config } from "../App";
  import './VideosPlay.css';
  import moment from 'moment';
  import {filteredMovie} from './VideoCard';
  import VideoCard from "./VideoCard";
  import Divider from '@mui/material/Divider';
  const VideoPlay = ()=>{
   
    const[movies, setMovies] = useState([]);
    const url = config.endpoint+`/video`;
    const { enqueueSnackbar } = useSnackbar();
        const params = useParams();
        const videoid = params._id;
        console.log("videoid",videoid);
       //console.log("params id", params._id);

    const performAPICall = async () => {
            try{
                const res = await axios.get(url);
                setMovies(res.data.videos);
                console.log(res.data.videos);
                return res.data;
            }
            catch(error){
              enqueueSnackbar(error.response.message, { variant: "error" });
              console.log(error);
            }
            
      };
     
      useEffect(() => {
        
          performAPICall();
         
      },[]);
     

        return(
            <>
            <Box>

            <Box className="top-pannel">
            <Header/>
            </Box>
            <Grid className = "card-text">
              <VideoCard videoid={videoid}/>
              <Divider orientation="horizontal" flexItem sx={{backgroundColor:"#D8D8D8", marginBottom:"0.8rem"}}/>
             <Grid  container spacing={1} >
                  {movies.map((movie) => {
                return (
                  <Grid item xs={12} sm={4} md={3} key={movie._id} sx={{width:'3rem'}}>
                    <MovieCard product={movie}/>
                  </Grid>
                );
              })}
              </Grid>

            </Grid>
            </Box>
            
           
            </>
        )
  }

  export default VideoPlay;